/**
 * Renders raw bytes as a lowercase hex string, two characters per byte. Shared by every
 * caller that turns a digest or a block of random bytes into text — the three call sites
 * this replaces (`multipart.ts`'s boundary, `crypto.ts`'s session-key derivation, and
 * `attachment.ts`'s content-derived upload key) had each written the same byte-to-hex map
 * independently.
 */
export function bytesToHex(bytes: ArrayBuffer | Uint8Array): string {
  const array = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
